import { graphql, navigate } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from '../../components/common/layout';
import Loader from '../../components/common/loader/loader';
import { SEO } from '../../components/common/seo';
import { getPopularRecommend } from '../../utils/recombee/client';
import { getRandomItems } from '../../utils/recombee/utils';
import { LearnPage } from '../learn';
import type { HomepageProps } from './types';

const IndexPage = ({ data, pageContext, ...props }: HomepageProps) => {
    const { articles } = pageContext;

    const { t, i18n } = useTranslation();

    const [popularPosts, setPopularPosts] = useState([]);

    useEffect(() => {
        const articleFilteredByLanguage = Object.values(articles).filter((article) => article.locale.includes(i18n.language));

        const arrayId = articleFilteredByLanguage.map((article) => String(article.id));

        const ids = getRandomItems(arrayId, 10).filter((id) => id);
        const popular = ids.map((item) => ({ node: articles[item] }));
        setPopularPosts(popular);

        getPopularRecommend(i18n.language).then((res) => {
            const { recomms } = res;
            if (recomms.length > 0) {
                const result = recomms.reduce((obj, item) => {
                    if (articles[item.id]) {
                        obj.push({ node: articles[item.id] });
                    }
                    return obj;
                }, []);
                if (result.length > 0) {
                    setPopularPosts(result);
                }
            }
        });
    }, [articles, i18n.language]);

    useEffect(() => {
        if (
            typeof window !== 'undefined' &&
            (window.location.pathname.includes('/trade-pro') || window.location.pathname.includes('/en'))
        ) {
            navigate('/');
        }
    }, []);
    return (
        <Layout searchBarOnHeader={false} {...props}>
            <SEO title={`${t('general.seo.learn_trade', 'Learn Trade')} | trades.org`} />
            {popularPosts.length > 0 ? <LearnPage data={data} popularPosts={popularPosts} /> : <Loader />}
        </Layout>
    );
};

export const query = graphql`
    query ($lang: String) {
        allStrapiArticle(
            filter: {
                intended_audience: { in: ["pros", "all"] }
                isActive: { eq: true }
                locale: { eq: $lang }
            }
            limit: 18
            sort: { order: DESC, fields: publishedAt }
        ) {
            edges {
                node {
                    id: strapi_id
                    title
                    publishedAt
                    isActive
                    content {
                        data {
                            content
                        }
                    }
                    locale
                    authors {
                        id
                        first_name
                        last_name
                        createdAt
                        updatedAt
                    }
                    slug
                    slide_image: header_image {
                        CloudinaryImageFromStrapi(quality: 90)
                    }
                }
            }
        }
        featured: allStrapiArticle(
            filter: {
                intended_audience: { in: ["pros", "all"] }
                isActive: { eq: true }
                locale: { eq: $lang }
            }
            limit: 1
        ) {
            edges {
                node {
                    id: strapi_id
                    title
                    publishedAt
                    isActive
                    content {
                        data {
                            content
                        }
                    }
                    locale
                    authors {
                        id
                        first_name
                        last_name
                        createdAt
                        updatedAt
                    }
                    slug
                    header_image {
                        CloudinaryImageFromStrapi(quality: 90)
                    }
                }
            }
        }
    }
`;

export default IndexPage;
